"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ripple = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const style_module_css_1 = __importDefault(require("./style.module.css"));
function Ripple({ color = '#7f58af', size = 80, className, style, }) {
    const circles = [...Array(2)].map((_, index) => ((0, jsx_runtime_1.jsx)("div", { style: {
            borderColor: `${color}`,
            borderWidth: size * 0.05,
        } }, index)));
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(style_module_css_1.default['lds-ripple'], className), style: { width: size, height: size, ...style }, children: circles }));
}
exports.Ripple = Ripple;
//# sourceMappingURL=ripple.js.map